import { MdDelete } from 'react-icons/md';
import { Button, Icon, Modal, ModalFooter } from '@nbirl/nbi-common-ui-libs';

type DeleteDocumentModalProps = {
  isOpen: boolean;
  onCloseModal: () => void;
  onDeleteDocument: () => void;
};

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({
  isOpen,
  onCloseModal,
  onDeleteDocument,
}) => (
  <Modal
    heading="Delete document?"
    isOpen={isOpen}
    headingIcon={<Icon icon={<MdDelete />} />}
    onDismiss={onCloseModal}
  >
    Are you sure you want to delete this document? It will be permanently
    deleted and you will no longer have access to it.
    <ModalFooter>
      <Button onClick={onCloseModal} variant="outline">
        No, cancel
      </Button>
      <Button onClick={onDeleteDocument}>Yes, delete</Button>
    </ModalFooter>
  </Modal>
);
